import dayjs from 'dayjs';
import { FirestoreRoutineActivity } from '../../../../data-access/types';
import { getDiffMinBetweenHHmm, transformHHmmToDate } from '../../../../data-access';

interface ValidationErrorResult {
  section: 'name' | 'time' | 'category';
  error: string;
  errorKey: string;
}

export const validateRoutineActivity = (
  activity: FirestoreRoutineActivity,
  options?: { timePreferencesEnabled?: boolean }
) => {
  const errors: ValidationErrorResult[] = [];

  if (activity.durationMin === 0) {
    errors.push({
      section: 'time',
      error: 'Duration must be greater than 0',
      errorKey: 'routine.validation.durationGreaterThanZero',
    });
  }

  const timePreferencesEnabled =
    options?.timePreferencesEnabled ?? Boolean(activity.startTime || activity.endTime);

  if (timePreferencesEnabled) {
    if (!activity.startTime || !activity.endTime) {
      errors.push({
        section: 'time',
        error: 'Start and end time are required when time preferences are enabled',
        errorKey: 'routine.validation.timeRequired',
      });
    } else {
      const isStartBeforeEnd = dayjs(transformHHmmToDate(activity.startTime)).isBefore(
        dayjs(transformHHmmToDate(activity.endTime))
      );
      if (!isStartBeforeEnd) {
        errors.push({
          section: 'time',
          error: 'Start time must be before end time',
          errorKey: 'routine.validation.startBeforeEnd',
        });
      }

      const isDurationLongerThanMax =
        getDiffMinBetweenHHmm(activity.startTime, activity.endTime) < activity.durationMin;
      if (isDurationLongerThanMax) {
        errors.push({
          section: 'time',
          error: 'Duration must be less than the time between start and end',
          errorKey: 'routine.validation.durationLessThanWindow',
        });
      }
    }
  }

  if (!activity.category) {
    errors.push({
      section: 'category',
      error: 'Category is required',
      errorKey: 'routine.validation.categoryRequired',
    });
  }

  if (!activity.name) {
    errors.push({
      section: 'name',
      error: 'Name is required',
      errorKey: 'routine.validation.nameRequired',
    });
  }

  return errors;
};
